/* OTERVANO: variant-aware story photo. No fetches, gallery changes or catalog writes. */
(() => {
  'use strict';
  if (customElements.get('ov-variant-story-photo')) return;
  class VariantStoryPhoto extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.disconnectListeners();
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.figure = this.closest('[data-ovsp-figure]');
        this.templates = new Map([...this.querySelectorAll('template[data-ovsp-variant]')].map(t => [t.dataset.ovspVariant, t]));
        if (!this.figure || !this.templates.size) return;
        this.scope = this.closest('#MainContent') || document;
        const onVariant = data => {
          const info = this.productInfo();
          const sectionId = info?.sectionId || info?.dataset.section;
          if (!data?.variant || (data.sectionId && sectionId && String(data.sectionId) !== String(sectionId))) return;
          this.show(String(data.variant.id));
        };
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, payload => onVariant(payload?.data));
        }
        document.addEventListener('variant:change', e => onVariant(e.detail), options);
        document.addEventListener('change', e => {
          const input = e.target;
          if (!(input instanceof Element) || !input.matches('input[name="id"]')) return;
          if (input.closest('product-info') !== this.productInfo()) return;
          this.show(String(input.value));
        }, options);
        const image = this.figure.querySelector(':scope > img[data-ovsp-image]');
        this.applyFit(image);
        const id = this.productInfo()?.querySelector('form input[name="id"]')?.value;
        if (id) this.show(String(id));
        this.dataset.ready = 'true';
      });
    }
    productInfo() {
      return this.scope?.querySelector('product-info[id^="MainProduct"]') || this.scope?.querySelector('product-info');
    }
    applyFit(image) {
      if (!image) return;
      this.figure.dataset.fit = image.dataset.ovspFit || 'contain';
      this.figure.style.setProperty('--photo-position', image.dataset.ovspFocus || 'center');
    }
    show(id) {
      if (!this.isConnected || !this.templates?.has(id) || id === this.dataset.variant) return;
      const source = this.templates.get(id).content.querySelector('img[data-ovsp-image]');
      const current = this.figure.querySelector(':scope > img[data-ovsp-image]');
      if (!source || !current) return;
      const image = source.cloneNode(true);
      // Replace src and srcset together so a previously selected color cannot linger.
      current.replaceWith(image);
      this.applyFit(image);
      this.dataset.variant = id;
    }
    disconnectListeners() {
      this.unsubscribe?.(); this.unsubscribe = null;
      this.abort?.abort(); this.abort = null;
    }
    disconnectedCallback() { this.disconnectListeners(); }
  }
  customElements.define('ov-variant-story-photo', VariantStoryPhoto);
})();
